import React, {useState} from 'react';
import PersonalInfo from "./PersonalInfo";
import ConfirmationModel from "../ConfirmationModel";
import axios from "axios";
import {handleError, showsuccesToast} from "../HandleError";
import localized from '../../i18n';
import {useNavigate} from "react-router-dom";
import deleteIcon from "../../assets/images/logo/delete.svg"

const SettingsForm = (props) => {
    const navigate = useNavigate();
    const {user} = props;
    const [deleteAccountModel, setDeleteAccountModel] = useState(false);

    const toggleLogoutModel = () => {
        setDeleteAccountModel(!deleteAccountModel);
    }


    const deleteAccount = (values, setSubmitting) => {
        setSubmitting(true);
        return axios.delete('/api/account/delete')
            .then((res) => {
                setSubmitting(false);
                navigate("/login");
                toggleLogoutModel();
                showsuccesToast(localized.account_deleted_successfully);
            }).catch((err) => {
                setSubmitting(false);
                handleError(err);
            })
    }

    return (
        <div className="setting-info-container">
            <div className="setting-info-main">
                <div className="setting-info-inner">
                    <PersonalInfo user={user}/>
                </div>
            </div>
            <div className="delete-account justify-content-end">
                <button className="delete-btn" onClick={toggleLogoutModel}> <img src={deleteIcon}/>{localized.delete}</button>
            </div>

            <ConfirmationModel
                title={localized.are_you_sure_want_to_delete_this_account}
                isOpen={deleteAccountModel}
                submitBtn={localized.delete}
                className="logout-modal"
                onClose={toggleLogoutModel}
                onSubmit={deleteAccount}
            />
        </div>
    );
};

export default SettingsForm;